<template>
  <div>
    <b-form-group :label="$t('Queries condition:')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-select v-model="queriesConditions" :options="queriesConditionsOpts"/>
    </b-form-group>
    <md-button @click.stop="addItem" class="md-raised md-dense">{{ $t('Add') }}</md-button>
    <md-button @click.stop="clearItems" class="md-raised md-dense">{{ $t('Clear') }}</md-button>
    <b-table striped hover small responsive
          :items="tableData"
          :fields="extSearchFields">
          <template v-slot:cell(field)="row">
            <b-select size="sm" v-model="row.item.field" :options="fieldOptions"/>
          </template>
          <template v-slot:cell(condition)="row">
            <b-select v-if="getItemType(row.item.field)!='yesno'" size="sm" v-model="row.item.condition" :options="conditionOptions"/>
          </template>
          <template v-slot:cell(value)="row">
            <b-form-input v-if="getItemType(row.item.field)=='text'" size="sm" v-model="row.item.value"/>
            <flat-picker v-if="getItemType(row.item.field)=='date'"
              @onDateChanged="(unixDate) => {row.item.value = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta( new Date()/1000 ).toDate())}"
            />
            <b-form-checkbox  size="md" v-if="getItemType(row.item.field)=='yesno'" switch v-model="row.item.value"
            value="1"
            unchecked-value="0" />
          </template>
          <template v-slot:cell(actions)="row">
            <i @click.stop="delItem(row)" class="danger fa fa-trash-alt fa-lg"/>
          </template>
        </b-table>

    <modal-ok-cancel @save="search" @cancel="$bvModal.hide('ExtSearch')" :buttonSaveLebel=" $t('Search')" size="lg"/>
  </div>
</template>

<script>

export default {
  data () {
    return {
      queriesConditions: '',
      queriesConditionsOpts: [
        {value: '', text: this.$i18n.t('at least one')},
        {value: 'and', text: this.$i18n.t('logical AND')},
        {value: 'all_for_one', text: this.$i18n.t('all for ONE account')}
      ],
      extSearchFields: [
        {key: 'field', label: this.$i18n.t('Field Name'), sortable: true},
        {key: 'condition', label: this.$i18n.t('Condition'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      tableData: [],
      fieldOptions: [
        {value: 'user_id', text: this.$i18n.t('Customer ID'), type: 'text'},
        {value: 'login', text: this.$i18n.t('Login'), type: 'text'},
        {value: 'password', text: this.$i18n.t('Password'), type: 'text'},
        {value: 'balance', text: this.$i18n.t('Balance'), type: 'text'},
        {value: 'basic_account', text: this.$i18n.t('Basic account'), type: 'text'},
        {value: 'full_name', text: this.$i18n.t('Full name'), type: 'text'},
        {value: 'email', text: 'Email', type: 'text'},
        {value: 'contract_id', text: this.$i18n.t('Documents ID'), type: 'text'},
        {value: 'advance_payment', text: this.$i18n.t('Payment in advance'), type: 'yesno'},
        {value: 'slink_id', text: this.$i18n.t('Link ID'), type: 'text'},
        {value: 'group_id', text: this.$i18n.t('Group ID'), type: 'text'},
        {value: 'account_id', text: this.$i18n.t('Account ID'), type: 'text'},
        {value: 'house_comment', text: this.$i18n.t('Address comment'), type: 'text'},
        {value: 'comment', text: this.$i18n.t('Comment'), type: 'text'},
        {value: 'service_name', text: this.$i18n.t('Service name'), type: 'text'},
        {value: 'accounting_period_id', text: this.$i18n.t('Accounting period ID'), type: 'text'},
        {value: 'policy_id', text: this.$i18n.t('Charge policy ID'), type: 'text'},
        {value: 'house_id', text: this.$i18n.t('House ID'), type: 'text'},
        {value: 'service_id', text: this.$i18n.t('Service ID'), type: 'text'},
        {value: 'tariff_id', text: this.$i18n.t('Tariff ID'), type: 'text'},
        {value: 'parent_id', text: this.$i18n.t('Parent service ID'), type: 'text'},
        {value: 'ip', text: 'IP', type: 'text'},
        {value: 'mask', text: this.$i18n.t('Net Mask'), type: 'text'},
        {value: 'allowed_cid', text: this.$i18n.t('Allowed CID'), type: 'text'},
        {value: 'mac', text: 'MAC', type: 'text'},
        {value: 'pool_id', text: this.$i18n.t('Pool ID'), type: 'text'},
        {value: 'pool_name', text: this.$i18n.t('Pool name'), type: 'text'},
        {value: 'nfprovider_id', text: this.$i18n.t('NetFlow provider'), type: 'text'},
        {value: 'switch_id', text: this.$i18n.t('Switch ID'), type: 'text'},
        {value: 'port_id', text: this.$i18n.t('Port'), type: 'text'},
        {value: 'vlan_id', text: 'VLAN', type: 'text'},
        {value: 'who_create', text: this.$i18n.t('Created by'), type: 'text'},
        {value: 'create_date', text: this.$i18n.t('Created on'), type: 'date'},
        {value: 'who_change', text: this.$i18n.t('Modified by'), type: 'text'},
        {value: 'last_change_date', text: this.$i18n.t('Last modified on'), type: 'date'},
        {value: 'juridical_address', text: this.$i18n.t('Legal address'), type: 'text'},
        {value: 'actual_address', text: this.$i18n.t('Actual address'), type: 'text'},
        {value: 'work_telephone', text: this.$i18n.t('Work phone'), type: 'text'},
        {value: 'home_telephone', text: this.$i18n.t('Home phone'), type: 'text'},
        {value: 'mobile_telephone', text: this.$i18n.t('Mobile phone'), type: 'text'},
        {value: 'web_page', text: this.$i18n.t('WebPage'), type: 'text'},
        {value: 'icq_number', text: this.$i18n.t('ICQ number'), type: 'text'},
        {value: 'tax_number', text: this.$i18n.t('ITIN'), type: 'text'},
        {value: 'kpp_number', text: this.$i18n.t('Reg code'), type: 'text'},
        {value: 'bank_id', text: this.$i18n.t('Bank ID'), type: 'text'},
        {value: 'bank_account', text: this.$i18n.t('Bank account'), type: 'text'},
        {value: 'comments', text: this.$i18n.t('Comments'), type: 'text'},
        {value: 'personal_manager', text: this.$i18n.t('Personal manager'), type: 'text'},
        {value: 'connect_date', text: this.$i18n.t('Connected on'), type: 'date'},
        {value: 'flat_number', text: this.$i18n.t('Apartment'), type: 'text'},
        {value: 'entrance', text: this.$i18n.t('Porch'), type: 'text'},
        {value: 'floor', text: this.$i18n.t('Floor'), type: 'text'},
        {value: 'district', text: this.$i18n.t('District'), type: 'text'},
        {value: 'building', text: this.$i18n.t('Building'), type: 'text'},
        {value: 'passport', text: this.$i18n.t('Passport'), type: 'text'},
        {value: 'remote_switch_id', text: this.$i18n.t('Router'), type: 'text'},
        {value: 'port_number', text: this.$i18n.t('Port'), type: 'text'},
        {value: 'doc_profile_id', text: this.$i18n.t('Profile of documents'), type: 'text'},
        {value: 'slink_login', text: this.$i18n.t('Slink login'), type: 'text'},
        {value: 'ip_group_id', text: this.$i18n.t('Ip group ID'), type: 'text'},
        {value: 'external_id', text: this.$i18n.t('External ID'), type: 'text'},
        {value: 'access_card_number', text: this.$i18n.t('Access card number'), type: 'text'},
        {value: 'active_block_id', text: this.$i18n.t('Active block ID'), type: 'text'},
        {value: 'int_status', text: this.$i18n.t('Internet status[1,0]'), type: 'yesno'},
        {value: 'freezed_balance', text: this.$i18n.t('Freezed balance'), type: 'text'},
        {value: 'credit', text: this.$i18n.t('Credit'), type: 'text'},
        {value: 'current_tariff_id', text: this.$i18n.t('Current tariff ID'), type: 'text'},
        {value: 'next_tariff_id', text: this.$i18n.t('Next tariff ID'), type: 'text'},
        {value: 'block_type', text: this.$i18n.t('BlockType [none,admin,system,user]'), type: 'text'},
        {value: 'tel_number', text: this.$i18n.t('Distributed telephone numbers'), type: 'text'},
        {value: 'incoming_trunk', text: this.$i18n.t('Incoming trunk'), type: 'text'},
        {value: 'outgoing_trunk', text: this.$i18n.t('Outcoming trunk'), type: 'text'},
        {value: 'contract_number', text: this.$i18n.t('Contract number'), type: 'text'},
        {value: 'signature_date', text: this.$i18n.t('Signature date'), type: 'date'},
        {value: 'contract_close_date', text: this.$i18n.t('Contract close date'), type: 'date'},
        {value: 'mobile_telephone_second', text: this.$i18n.t('Mobile phone secondary'), type: 'text'}
      ],
      conditionOptions: [
        {value: 'equal', text: this.$i18n.t('Equal')},
        {value: 'nonequal', text: this.$i18n.t('Nonequal')},
        {value: 'contain', text: this.$i18n.t('Contain')},
        {value: 'noncontain', text: this.$i18n.t('Noncontain')},
        {value: 'greater', text: this.$i18n.t('Greater')},
        {value: 'lesser', text: this.$i18n.t('Lesser')}
      ],
      deleteImg: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    getItemType (val) {
      for (let el of this.fieldOptions) {
        if (el.value === val) {
          return el.type
        }
      }
    },
    addItem () {
      let it = {
        value: '',
        field: 'login',
        condition: 'contain',
        type: 'text'
      }
      this.tableData.push(it)
    },
    delItem (row) {
      this.tableData = this.tableData.filter((value) => {
        return value !== row.item
      })
    },
    search () {
      let body = {queries: [], page: 1, per_page: 20, queries_conditions: this.queriesConditions}
      for (let el of this.tableData) {
        let it = {
          field: el.field,
          value: String(el.value),
          condition: el.condition
        }
        body.queries.push(it)
      }
      localStorage.setItem('ExtSearch', JSON.stringify(this.tableData))
      this.$emit('loadFromExtSearch', body)
    },
    clearItems () {
      this.tableData = []
      this.addItem()
      localStorage.setItem('ExtSearch', JSON.stringify(this.tableData))
    }
  },
  mounted () {
    let extSearchData = localStorage.getItem('ExtSearch')
    if (extSearchData !== null) {
      this.tableData = JSON.parse(extSearchData)
    } else {
      this.addItem()
    }

    this.fieldOptions = this.fieldOptions.sort(function (a, b) {
      if (a.text > b.text) {
        return 1
      }
      if (a.text < b.text) {
        return -1
      }
      return 0
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/formExtSearch.vue